import { render } from "./SubSetting.vue?vue&type=template&id=f2737054&scoped=true"
const script = {}

import "./SubSetting.vue?vue&type=style&index=0&id=f2737054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2737054"]])

export default __exports__